<template>
  <div class="flex flex-direction align-center justify-start viewConent view">
    <nav backgroundColor="#ace3cb"></nav>
    <div class="fixed-view">
      <div class="text-center text-center-def">
        <div class="note">
          <div class="note-title">征集时间</div>
        </div>
        <div>即日起至2023年9月30日</div>
        <div class="note">
          <div class="note-title">主办</div>
        </div>
        <div>中共宜昌市委宣传部</div>
        <div>宜昌市农业农村局</div>
        <div>宜昌市乡村振兴局</div>
        <div class="note">
          <div class="note-title">承办</div>
        </div>
        <div>宜昌三峡日报新媒体有限责任公司</div>
      </div>
      <div class="flex align-center justify-center margin-top-xxl" style="position: relative;">
        <div>
          <wxlite class="hidden-sm-and-up" :activity="activity179375" :diySetting="activity179375"></wxlite>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import App from '../util/comfun'
  import brand from '../components/brand.vue'
  import wxlite from '../components/wxlite.vue'
  //import 'element-ui/lib/theme-chalk/display.css';
  export default {
    data () {
      return {
        activity179375:{
          activityId:179375,
          className:'cla-179375',
          buttonName:'我要投视频',
          activityName:'“影像中的和美乡村”短视频征集活动',
          hideShareMenu:true,
        },
      }
    },
    components:{
      brand,
      wxlite,
    },
    methods:{

    },
    mounted(){
    },

  }
</script>

<style scoped>
  .viewConent{
    width: 100vw;
    height: 100vh;
    background-color: #3CB087;
    position: relative;
    background-image: url("https://assets.pfotoo.com/179375/bg.jpg?3");
    background-repeat: no-repeat;
    background-size: 100% auto;
  }
  .viewConent:before{
    background-image: url("https://assets.pfotoo.com/179375/bottom.png");
    background-size: 100% 100%;
    width: 100%;
    content: "";
    height: 102px;
    position: absolute;
    bottom: 0;
  }
  .text-center-def{
    font-weight: 400;
    font-size: 15.2px;
    text-align: left;
    color: #03311C;
    letter-spacing: 1.2px;
  }
  .note{
    width: 86.7px;
    height: 17.6px;
    background-image: url("https://assets.pfotoo.com/179375/line.png");
    background-position: 10px 12px;
    background-size: 86.7px 7.19px;
    background-repeat: no-repeat;
    line-height: 17.6px;

    margin-top: 16px;
    margin-bottom: 10px;
  }
  .note-title{
    font-weight: 700;
    font-size: 18px;
    text-align: left;
    color: #FFFFFF;
    letter-spacing: 1.6px;
    text-shadow: 1.6px 2.8px 6.8px 0.4px #19684dbf;
  }
  .fixed-view{
    position: fixed;
    bottom: 110px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/activity179375.vue